import { render, staticRenderFns } from "./r-card-dialog.vue?vue&type=template&id=04b4b334&scoped=true"
import script from "./r-card-dialog.vue?vue&type=script&lang=js"
export * from "./r-card-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-card-dialog.vue?vue&type=style&index=0&id=04b4b334&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4b334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b4b334')) {
      api.createRecord('04b4b334', component.options)
    } else {
      api.reload('04b4b334', component.options)
    }
    module.hot.accept("./r-card-dialog.vue?vue&type=template&id=04b4b334&scoped=true", function () {
      api.rerender('04b4b334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card/r-card-dialog.vue"
export default component.exports